import { apiPaths } from '@/services/api/paths';
import { api, TCustomAxiosPaginationResponse } from '..';

export const getSearchOrganizations = async (
  searchText: string,
): Promise<TCustomAxiosPaginationResponse<{ id: string; name: string; logoUrl: string }[]>> => {
  const { data } = await api.get(apiPaths.superAdmin.searchOrganizations, {
    params: {
      query: searchText,
    },
  });

  return data;
};

export const postOrganizationSelection = async (organizationId: string): Promise<void> => {
  await api.post(apiPaths.superAdmin.selectOrganization, { organizationId });
};

export const getCurrentOrganizationContext = async (): Promise<{
  organizationId: string;
  organizationName: string;
  expiresAt: string;
} | null> => {
  const { data } = await api.get(apiPaths.superAdmin.currentContext);

  const response = data.data;

  return response;
};

export const deleteOrganizationContext = async (): Promise<void> => {
  await api.delete(apiPaths.superAdmin.clearOrganization);
};
